import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-calibracion',
  templateUrl: './calibracion.component.html',
  styleUrls: ['./calibracion.component.scss']
})

export class CalibracionComponent implements OnInit {

  showDialog = true;
  dialogInfo = 'humedad';

  router;

  constructor(router: Router) {
    this.router = router;
   }
  ngOnInit() {
  }

  redirectTo(path: string): void {
    this.router.navigate([path]);
  }
}
